import * as React from 'react';
import { useSelector } from 'react-redux';

import { LegalCheck } from '@cian/ui-kit';
import { getMarketingAgreementUrl, getPrivacyPolicyUrl } from './utils';
import { getPersonalDataAgreementUrl } from './utils/getPersonalDataAgreementUrl';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { selectFormMarketingAgreement } from '../../../selectors/requestFormV2';
import { setMarketingAgreement } from '../../../slices/agreements';
import { useApplicationContext } from '../../../utils/applicationContext';

export const PersonalAgreementContainer = () => {
  const dispatch = useAppDispatch();
  const { config } = useApplicationContext();
  const marketingAgreementChecked = useSelector(selectFormMarketingAgreement);

  const handleCheckedChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      dispatch(setMarketingAgreement(value));
    },
    [dispatch],
  );

  const privacyPolicyUrl = getPrivacyPolicyUrl(config);
  const personalDataUrl = getPersonalDataAgreementUrl(config);
  const marketingAgreementUrl = getMarketingAgreementUrl(config);

  return (
    <LegalCheck
      privacyPolicyUrl={privacyPolicyUrl}
      personalDataUrl={personalDataUrl}
      marketingAgreementUrl={marketingAgreementUrl}
      checked={marketingAgreementChecked}
      onCheckedChange={handleCheckedChange}
    />
  );
};
